<div class="flex flex-column h-full w-full">
    <ng-content select="[app-scrollable-header]"></ng-content>
    <div
        class="flex-fill w-full"
    >
        <div class="pr-4">
            <ng-content></ng-content>
        </div>
    </div>
</div>
